import userGroupEpicsMap from "./userGroups.epics";
import * as userGroupReducers from "./userGroups.reducers";
import { objectValues } from "@ea/shared_components/utils/object";

const userGroupEpics = objectValues(userGroupEpicsMap);

export { userGroupReducers, userGroupEpics };
